<div class="contractor-head-count-container">
  <div class="container">
    <div class="header">
      <div class="tab-icon">
        <h2>{{ ContractorHeadCountLabels.ContractorHeadcount }}</h2>
        <emerald-icon
          [icon]="'open_in_new'"
          [color]="priority.grey"
          [fontsizeInRem]="1.2"
          (click)="navigateToContractorsList()"
        >
        </emerald-icon>
      </div>

      <div class="date-container-dropdown">
        <emerald-dropdown
          [options]="month"
          [outlined]="true"
          [id]="'single_select'"
          [label]="'Month'"
          (onChange)="valueSelect($event)"
        ></emerald-dropdown>
      </div>
    </div>

    <div class="visual">
      <div class="donut">
        <svg viewBox="0 0 72 72" class="donut-svg" aria-hidden="true">
          <circle class="donut-track" cx="36" cy="36" r="28"></circle>
          <circle
            *ngFor="let seg of donutSegments"
            class="donut-segment"
            cx="36"
            cy="36"
            r="28"
            [attr.stroke]="seg.color"
            [attr.stroke-dasharray]="seg.dashArray"
            [attr.stroke-dashoffset]="seg.dashOffset"
          ></circle>
        </svg>
        <div class="donut-center">
          <span class="donut-value">{{ totalContractor }}</span>
          <span class="donut-label">TOTAL</span>
        </div>
      </div>
      <div class="breakdown">
        <div class="bd-tile" [style.border-left-color]="headcountColors.onBoarded">
          <span class="bd-value" [style.color]="headcountColors.onBoarded">{{ contractorOnBoarded }}</span>
          <span class="bd-label">{{ ContractorHeadCountLabels.OnBoarded }}</span>
        </div>
        <div class="bd-tile" [style.border-left-color]="headcountColors.offBoarded">
          <span class="bd-value" [style.color]="headcountColors.offBoarded">{{ contractorOffBoarded }}</span>
          <span class="bd-label">{{ ContractorHeadCountLabels.OffBoarded }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
